import { inject, observer } from 'mobx-react';
import { isEmpty } from '@/utils';
import { formatPriceThousands } from '@/utils/configs/price.config';
import PayLaterComponent from '@/components/PayLaterComponent';
import KlarnaMessage from '@/components/KlarnaMessage';
import { enableKlarna, enablePaypal } from '@/utils/configs/payment.config';
import styles from './index.module.less';

/**
 * 产品价格
 * @param {string} from stickyBar 底部导航 | page 默认
 * @param {object} style
 */
const Index = inject(
  'area',
  'product',
  'app'
)(
  observer((props) => {
    const {
      productTotalPrice,
      curSelectCommodity: { isOutOfStock, id: cid, price },
      productDetail: { id: pid, isNeedHidePrice },
    } = props.product;
    const {
      style = {},
      from = 'page',
      totalPrice = {},
      app: { isMobile },
      area: {
        LANG,
        country,
        country: { code },
      },
    } = props;
    /** props中获得的价格参数优先级高 */
    const priceObj = isEmpty(totalPrice, true) ? productTotalPrice : totalPrice;
    const { amount, amountOrigin, currency, signal, hasDiscount } = priceObj;

    if (amount === 0) return null;
    if (isNeedHidePrice) return null;
    const isFromStikyBar = from === 'stickyBar';
    let showKlarna = enableKlarna({ code, p_c_ids: [{ pid, cid }], currency: price?.currency });
    let showPayLater = enablePaypal({ code, p_c_ids: [{ pid, cid }] });

    return (
      <div className={styles.productPrice} data-from={from} style={style}>
        <div className={styles.priceWrap}>
          <div className={[styles.price, isOutOfStock || !hasDiscount ? styles.outOfStock : ''].join(' ')}>
            <div className={styles.nowPrice}>
              {formatPriceThousands({
                price: amount,
                signal: signal,
                currency: currency,
                country,
              })}
            </div>
          </div>
          {hasDiscount && (
            <div className={styles.saveWrap}>
              <span className={styles.save}>
                {LANG['productNew.label.save_price']?.replace(
                  '__price__',
                  formatPriceThousands({ price: amountOrigin - amount, signal: signal, currency: currency, country })
                )}
              </span>
              {hasDiscount && (
                <span className={styles.originPrice}>
                  {formatPriceThousands({
                    price: amountOrigin,
                    signal: signal,
                    currency: currency,
                    country,
                  })}
                </span>
              )}
            </div>
          )}
        </div>
        {!isMobile && isOutOfStock && from !== 'page' && (
          <span className={styles.outOfStock}>{LANG['productNew.outOfStock_tip']}</span>
        )}
        {!isMobile && !isOutOfStock && from !== 'productlist' && (
          <div className={styles.paypentMsgWrap}>
            {showKlarna ? (
              <KlarnaMessage
                id={from}
                className={styles.klarnaMessage}
                dataKey='credit-promotion-auto-size'
                amount={amount}
                style={{ marginTop: 8 }}
              />
            ) : (
              showPayLater && (
                <PayLaterComponent
                  id={from}
                  amount={amount}
                  messageConfig={{ style: { text: isFromStikyBar ? { align: 'right', size: 12 } : { size: 14 } } }}
                  style={{
                    marginTop: 8,
                    height: isFromStikyBar ? 17 : 'auto',
                  }}
                />
              )
            )}
          </div>
        )}
      </div>
    );
  })
);

export default Index;
